import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useConnectivity } from "../../../hooks/useConnectivity";
import {
  setBrowserOnline,
  subscribeSyncState,
} from "../../../services/firebase/firestoreSyncService";

/** @typedef {import('../../services/firebase/firestoreSyncService').SyncServiceState} SyncServiceState */

const defaultState = {
  phase: "connecting",
  browserOnline: true,
  snapshotsInSync: true,
  hasPendingWrites: false,
  servingFromCache: false,
  persistenceReady: true,
  lastError: null,
  activeRoomId: null,
};

const SyncContext = createContext(/** @type {SyncServiceState} */ (defaultState));

export function OfflineProvider({ children }) {
  const { online } = useConnectivity();
  const [serviceState, setServiceState] = useState(defaultState);

  useEffect(() => {
    return subscribeSyncState(setServiceState);
  }, []);

  useEffect(() => {
    setBrowserOnline(online);
  }, [online]);

  const value = useMemo(() => serviceState, [serviceState]);

  return <SyncContext.Provider value={value}>{children}</SyncContext.Provider>;
}

export function useSyncContext() {
  return useContext(SyncContext);
}
